var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarTestimonial(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7653 17.0401C42.1002 5.68002 45.2651 0 50 0C54.7349 0 57.8998 5.68002 64.2347 17.0401L65.8746 19.9801C67.6746 23.2101 68.5746 24.8251 69.9745 25.8901C71.3745 26.9551 73.1245 27.3501 76.6244 28.1401L79.8043 28.8601C92.104 31.6451 98.2489 33.0351 99.7138 37.7401C101.174 42.4401 96.9839 47.3451 88.5991 57.1502L86.4291 59.6852C84.0492 62.4702 82.8542 63.8652 82.3192 65.5852C81.7842 67.3102 81.9642 69.1702 82.3242 72.8852L82.6542 76.2702C83.9192 89.3553 84.5542 95.8953 80.7243 98.8003C76.8944 101.71 71.1345 99.0553 59.6248 93.7553L56.6398 92.3853C53.3699 90.8753 51.735 90.1253 50 90.1253C48.265 90.1253 46.6301 90.8753 43.3551 92.3853L40.3802 93.7553C28.8655 99.0553 23.1056 101.705 19.2807 98.8053C15.4458 95.8953 16.0808 89.3553 17.3458 76.2702L17.6758 72.8902C18.0357 69.1702 18.2157 67.3102 17.6758 65.5902C17.1458 63.8652 15.9508 62.4702 13.5709 59.6902L11.4009 57.1502C3.01611 47.3501 -1.1738 42.4451 0.286168 37.7401C1.75113 33.0351 7.90099 31.6401 20.2007 28.8601L23.3806 28.1401C26.8755 27.3501 28.6205 26.9551 30.0255 25.8901C31.4254 24.8251 32.3254 23.2101 34.1254 19.9801L35.7653 17.0401Z",
    fill: "url(#paint0_linear_536_511)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_511",
    x1: 54.9985,
    y1: -0.00000177027,
    x2: 22.4978,
    y2: 94.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.173984,
    stopColor: "#FFEAA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECA57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarTestimonial);
export default __webpack_public_path__ + "static/media/star-testimonial.a94dce3d05b5f624274c5f2612b11a44.svg";
export { ForwardRef as ReactComponent };